import { getLanguage } from './global';

const BASE_URL = () => {
  const language = getLanguage();
  // eslint-disable-next-line no-restricted-globals
  const hosting: string = location.hostname;
  // console.log(`hosting is: ${hosting}`);
  // console.log(DEV_API_DOMAIN);

  if ((hosting === 'alemilani10.ddev.site') || (hosting === 'localhost')) {
    // console.log('Sono in return dev');
    return `https://alemilani10.ddev.site/${language}/`;
  }
  return `https://alessandromilaniliutaio.com/${language}/`;
};

export { BASE_URL };

const ROW_URL = () => {
  // eslint-disable-next-line no-restricted-globals
  const hosting: string = location.hostname;
  if ((hosting === 'alemilani10.ddev.site') || (hosting === 'localhost')) {
    // console.log('Sono in return dev');
    return 'https://alemilani10.ddev.site';
  }
  return 'https://alessandromilaniliutaio.com';
};

export { ROW_URL };
